module.exports = __webpack_public_path__ + "static/MB1-19b6f1fac6798de74e918be6d00e5284.jpg";